import Link from "next/link";
import BookImage from "@/components/BookImage";
import { seriesPageUrl } from "@/utils/routes";
import { Series } from "@/types/Series";

export function SeriesComponent(serie: Series) {
  const sortedBooks = [...serie.books].sort((a, b) => {
    if (a.volume === null) return 1;
    if (b.volume === null) return -1;
    return a.volume - b.volume;
  });

  return (
    <div className="max-md:w-full max-md:max-w-[400px] md:w-[160px]">
      <Link href={seriesPageUrl(serie.slug, "discover")}>
        <BookImage
          width={160}
          height={233}
          className="h-auto max-md:w-full max-w-[400px] md:h-[233px] md:w-[160px] object-cover m-auto md:hover:scale-105 transition-transform"
          book={sortedBooks[0]!}
        />
      </Link>

      <div className="flex justify-between">
        <div>
          <Link href={seriesPageUrl(serie.slug, "discover")} className="hover:underline">
            <h3 className="text-sm font-semibold mt-2">{serie.name}</h3>
          </Link>
          <p className="text-xs text-muted-foreground">{serie.author}</p>
        </div>
      </div>
    </div>
  );
}
